export const accountSessionKey = "_fcnt";
/** localStorage flag for QuickBooks Desktop connect / disconnect UI (see Home, Mapping). */
export const quickBooksDesktopLocalKey = "qbd";
/** temporary QuickBooks callback handle when user must sign in before saving QuickBooks tokens */
export const quickBooksCallbackPendingKey = "qbo_callback_pending";
export const getUserAccount = () => {
  let session = localStorage.getItem(accountSessionKey);
  if (session=== null) {
    return null;
  }
  let a = null;
  try {
    a = JSON.parse(decodeURIComponent(escape(atob(session))))
  } catch {
    localStorage.removeItem(accountSessionKey)
    return null;
  }
  if (a === null || a.access_token === undefined) {
    return null;
  }
  return a;
}


export function updateAccount(account) {
  var encodedAccount = btoa(unescape(encodeURIComponent(JSON.stringify(account))));
  localStorage.setItem(accountSessionKey, encodedAccount)
}

export function Logout() {
  localStorage.removeItem(accountSessionKey)
}
